import React from "react";
import styled, { css } from "styled-components";
import getConfig from "next/config";
import { Form } from "react-bootstrap";

import { hexToRGBA } from "../../../../utils/theme";

const { publicRuntimeConfig } = getConfig();

const StyledGroup = styled(Form.Group)`
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 10px;
  padding-bottom: 10px;

  border-bottom: 1px solid #eaeaea;

  ${({ hideDivider }) => hideDivider && css`
    border-bottom: none;
  `};
  
  input:checked,
  input:not(:checked) {
    position: absolute;
    top: 2px;
    left: 0;
  }

  input:checked + label,
  input:not(:checked) + label {
    display: inline-block;
    position: relative;
    padding-left: 20px;

    font-family: 'RobotoRegular';
    font-size: 13px;
    line-height: calc(1.42857rem * (13 / 16));
    color: #717171;

    cursor: pointer;
  }
`;

const StyledCheck = styled(Form.Check)`
  margin-right: 24px;
`;

function AgreementCheckbox({
  id,
  label = "Label",
  hideDivider,
}) {
  return (
    <StyledGroup
      controlId={id}
      className="custom-control-invalid"
      hideDivider={hideDivider}
    >
      <StyledCheck
        inline
        required
        type="checkbox"
        name={id}
        label={label}
      />
    </StyledGroup>
  );
}

export default AgreementCheckbox;
